export function getBrandById(state) {
  return (brandId) => {
    return state.allBrands[brandId];
  };
}

export function getTotalItemsForBrand(state) {
  return (brandId) => {
    const auctions = state.auctionsByBrand[brandId] || [];
    const listings = state.listingsByBrand[brandId] || [];

    return auctions.length + listings.length;
  };
}

export function getTotalItemsForProductLine(state) {
  return (productLineId) => {
    let total = 0;

    Object.values(state.auctionsByBrand).forEach((auctions) => {
      total += auctions.filter(
        (auction) => auction.product_line?.id === productLineId
      ).length;
    });

    Object.values(state.listingsByBrand).forEach((listings) => {
      total += listings.filter(
        (listing) => listing.product_line?.id === productLineId
      ).length;
    });

    Object.values(state.productsByBrand).forEach((products) => {
      total += products.filter(
        (product) => product.product_line?.id === productLineId
      ).length;
    });

    return total;
  };
}

export function getProductLineById(state) {
  return (productLineId) => {
    const productLines = state.productLines || [];
    return productLines.find((line) => line.id === productLineId);
  };
}

export function hasFulfillmentHubAccess(state) {
  return state.company?.addons_access.indexOf('fulfillment-hub') >= 0;
}

export function invoicingEnabled(state) {
  return state.company?.invoicing_enabled ?? true;
}

export function fulfillmentMode(state) {
  return state.company?.fulfillment_mode ?? 'all';
}

export function brandGroupedDocumentsEnabled(state) {
  return state.company?.brand_grouped_documents_enabled ?? false;
}

export function hasDataToolsAccess(state) {
  return state.company?.addons_access.indexOf('data-tools') >= 0;
}

export function getLicenses(state) {
  return state.licenses;
}

export function isMetrcCompany(state) {
  return state.company?.type?.code === 'metrc';
}

export function isNonMetrcCompany(state) {
  return state.company?.type?.code === 'non-metrc';
}
